module.exports = __webpack_public_path__ + "static/img/logowhitee.72f29119.png";